import { Input, InputProps } from "@chakra-ui/react";
import React from "react";

import { $g1Color } from "@/theme/G1Style";
import { Component } from "@utils/TypesAndConstants";

interface G1InputProps extends InputProps {
    component: Component ;
    disabled?: boolean ;
    registerInput?: any ;
}

export const G1Input = React.forwardRef<HTMLInputElement, G1InputProps>((props, ref) => {
    const { component, type, registerInput, onChange, onBlur, ...rest } = props ;
    const variant = (type === "search") ? "search" : "field" ;

    const { onChange: registerOnChange, onBlur: registerOnBlur, ...registerRest } = registerInput ?? {};

    return <Input 
        type={type}
        ref={ref}
        bg={$g1Color(`${component}.${variant}.bg`)}
        color={$g1Color(`${component}.${variant}.write`)}
        borderColor={$g1Color(`${component}.${variant}.border`)}
        _hover={{ borderColor: $g1Color(`${component}.${variant}.hover.border`) }}
        _focus={{ borderColor: $g1Color(`${component}.${variant}.select.border`) }}
        _placeholder={{ color: $g1Color(`${component}.${variant}.placeholder`) }}
        onChange={(e) => {
            registerOnChange?.(e);
            onChange?.(e);
        }}
        onBlur={(e) => {
            registerOnBlur?.(e);
            onBlur?.(e);
        }}
        {...registerRest}
        {...rest}
    /> ;
});